var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebinars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:gray}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(-257.828 -257.722) scale(1.85936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.31 234.28v-4.04c0-12.55-.02-25.09 0-37.64.02-13.56 10.5-23.89 24.38-23.9 34.97-.04 69.95-.03 104.92.01 13.59.02 23.85 9.26 24.37 22.55.39 9.76-.12 19.56-.2 29.34-.03 3.55-.04 7.1.08 10.64.08 2.19.93 3.37 3.7 3.28 8.26-.28 16.53-.24 24.8-.21 3.42.01 5.16 1.78 5.4 5.1.07 1.02.03 2.04.03 3.06v155.75c0 4.45 0 4.45 4.57 4.45 3.04 0 6.07-.02 9.11.02 2.4.03 4.7.93 5.05 3.27.26 1.74-.32 4.19-1.51 5.42-5.95 6.15-12.15 12.08-18.45 17.89-1.15 1.06-3.16 1.73-4.77 1.74-41.88.07-83.77.02-125.65.02-39.79 0-79.58.04-119.37.06-4.18 0-8.36.12-12.53-.09-1.45-.07-3.2-.61-4.22-1.55-6.13-5.68-12.07-11.57-18.13-17.33-1.97-1.87-3.13-3.92-1.95-6.54 1.13-2.52 3.49-2.95 6.05-2.92 3.45.05 6.91-.03 10.37.02 1.58.03 2.36-.55 2.24-2.14-.03-.41.01-.82.01-1.22 0-26.72-.02-53.44-.01-80.16 0-26.09 0-52.17.02-78.26 0-5.02 1.62-6.62 6.72-6.62 23.46-.01 46.91-.01 70.37-.01 1.33.01 2.68.01 4.6.01zm177.54 89.45v-75.3c0-4.49-.02-4.49-4.73-4.5-5.34 0-10.68.03-16.02-.01-1.78-.01-2.84.35-3.17 2.41-2.09 13.12-11.72 21.06-25.37 21.07-17.28.01-34.56-.04-51.84.07-1.74.01-3.73.63-5.16 1.59-9.54 6.46-18.96 13.08-28.4 19.67-2.03 1.42-4.07 2.64-6.63 1.29-2.52-1.32-2.72-3.63-2.7-6.07.03-4.69-.04-9.39.02-14.08.03-1.83-.68-2.59-2.59-2.5-2.19.1-4.4.04-6.6.01-12.15-.17-22.29-8.45-24.06-20.11-.44-2.88-1.49-3.41-4.11-3.4-21.26.07-42.52.04-63.78.05-4.14 0-4.16.02-4.16 4.11-.01 23.84 0 47.67 0 71.51v78.66c0 4.43.01 4.43 4.67 4.43h35.1c15.5 0 31-.08 46.5.02 14.07.1 9.54-1.65 19.63 7.72 1.13 1.05 3.05 1.77 4.63 1.81 7.33.19 14.69-.32 21.98.21 6.49.47 11.59-1.02 15.43-6.29 2.04-2.81 4.98-3.54 8.52-3.53 29.43.11 58.86.06 88.29.06 4.54 0 4.55 0 4.55-4.56v-74.34zm-134.09-47.42c1.71-1.11 2.59-1.65 3.43-2.24 6.64-4.62 13.31-9.2 19.87-13.92 2.55-1.83 5.16-2.7 8.39-2.68 17.91.13 35.81.15 53.72.05 9.55-.06 15.09-5.71 15.1-15 .01-16.22-.27-32.45.12-48.66.2-8.09-5.46-15.68-16.03-15.64-34.14.14-68.28.03-102.42.1-2.26 0-4.68.25-6.75 1.06-6.51 2.57-9.1 7.71-9.09 14.34.02 13.98 0 27.95.02 41.93.01 3.26-.13 6.55.25 9.78.82 7.07 6.55 11.97 13.86 12.09 4.19.07 8.38.01 12.57.02 5.28.01 6.92 1.6 6.96 6.77.02 3.74 0 7.47 0 12zm-16.95 145.18h3.7c.18-.3.37-.6.55-.89-2.26-2.09-4.4-4.33-6.82-6.23-1.18-.93-2.87-1.75-4.34-1.76-24.46-.23-48.92-.38-73.38-.43-8.99-.02-17.98.23-26.97.37-.75.01-1.49.19-2.37.3 4.7 5.94 8.49 7.82 17.97 8.66m254.23-8.08c-.17-.3-.35-.6-.52-.9h-3.71c-31.83 0-63.67.26-95.49-.19-7.47-.11-9.81 5.02-14.72 8.83 1.33.2 1.73.31 2.13.31 33.93.01 67.85.01 101.78-.02.88 0 1.97-.22 2.59-.75 2.71-2.35 5.3-4.84 7.94-7.28z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.85 300.04c-.05-15.64 12.71-28.2 28.79-28.34 15.89-.14 29.05 12.57 29.11 28.12.06 15.55-12.91 28.26-28.88 28.3-16.01.04-28.97-12.5-29.02-28.08zm28.82-18.67c-10.43.05-18.92 8.31-18.98 18.49-.07 10.07 8.96 18.85 19.23 18.71 10.43-.15 18.86-8.48 18.86-18.63 0-10.45-8.4-18.61-19.11-18.57z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.79 337.21c6.6 0 13.2-.13 19.79.03 12.48.3 22.46 9.58 23.48 21.65.34 3.98-1.17 6.28-4.31 6.58-3.23.31-5.12-1.58-5.54-5.54-.8-7.54-6.28-12.86-14.08-12.98-12.87-.2-25.76-.2-38.63-.01-8.14.12-13.27 5.23-14.21 13.5-.41 3.57-2.57 5.53-5.69 4.98-2.78-.49-4-2.28-4.09-4.99-.4-12.12 10.42-22.89 23.5-23.19 6.59-.16 13.19-.03 19.78-.03z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.1 332.86c-9.1 0-18.2-.01-27.3.01-2.32.01-4.39-.38-5.65-2.54-1.5-2.58-.31-5.8 2.63-6.69 1.27-.39 2.67-.47 4.02-.48 17.57-.03 35.15-.02 52.72-.02.73 0 1.47-.02 2.2.05 3.34.33 5.25 2.2 5.14 5.01-.11 2.81-2.09 4.6-5.51 4.62-9.42.08-18.83.04-28.25.04z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.16 318.74c0 8.87.05 17.74-.05 26.6-.02 1.46-.22 3.47-1.18 4.22-1.35 1.07-3.73 1.97-5.2 1.51-1.46-.45-3.14-2.6-3.3-4.15-.46-4.44-.22-8.95-.22-13.44-.01-13.35 0-26.7 0-40.06 0-1.12-.01-2.25.13-3.36.34-2.74 2.03-4.25 4.81-4.28 2.8-.03 4.55 1.54 4.88 4.21.26 2.11.12 4.27.13 6.41.01 7.46.01 14.9 0 22.34z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.23 285.73c9.32 0 18.63-.03 27.95.02 3.64.02 5.67 1.79 5.67 4.74.01 2.45-1.25 4.07-3.69 4.65-1.1.26-2.28.26-3.43.26-17.58.01-35.17.02-52.75 0-5.05 0-7.53-1.68-7.47-4.96.06-3.2 2.4-4.71 7.35-4.72 8.79 0 17.58 0 26.37.01z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.09 351.49c-9.21 0-18.42.02-27.63-.01-3.75-.01-5.97-1.86-5.96-4.8.01-2.91 2.26-4.75 6.04-4.76 18.42-.03 36.84-.02 55.26 0 3.95.01 6 1.66 6.05 4.68.06 3.14-2.07 4.87-6.14 4.88-9.2.02-18.41.01-27.62.01z",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.27 314.02c-9.3 0-18.61.02-27.91-.01-3.57-.01-5.77-1.81-5.84-4.62-.08-2.91 2.19-4.85 5.9-4.85 18.61-.02 37.21 0 55.82-.02 2.86 0 4.95 1.01 5.54 3.88.49 2.39-.57 4.25-2.85 5.2-1.01.42-2.24.41-3.38.41-9.1.03-18.19.01-27.28.01z",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.7 374.65c2.93 0 5.86-.07 8.79.02 4.12.12 5.73 1.7 5.82 5.62.06 2.75.09 5.51-.02 8.26-.11 3.01-2.05 4.99-4.75 5.09-2.82.1-4.77-1.92-5.16-5.07-.17-1.4-.5-3.83-1.11-3.93-2.41-.42-4.97-.18-7.45 0-.28.02-.59 1.18-.68 1.84-.14 1 0 2.05-.16 3.05-.4 2.53-2.55 4.31-5.03 4.08-2.59-.24-4.4-1.66-4.56-4.24-.21-3.45-.24-6.94 0-10.39.21-2.91 2.36-4.2 5.19-4.28 3.03-.09 6.07-.02 9.11-.02.01-.01.01-.02.01-.03z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.64 374.67c3.04 0 6.08-.11 9.11.03 3.65.16 5.25 1.87 5.31 5.45.05 2.75.06 5.51 0 8.26-.07 3.19-2.04 5.25-4.89 5.23-2.72-.02-4.56-2-4.87-4.99-.15-1.41-.42-3.89-1-4-2.42-.43-4.97-.21-7.47-.05-.31.02-.66 1.14-.77 1.79-.17 1.1-.05 2.25-.26 3.34-.5 2.59-2.32 3.9-4.89 3.86-2.43-.04-4.43-1.33-4.61-3.77-.28-3.75-.31-7.55 0-11.29.21-2.6 2.37-3.75 4.92-3.82 3.14-.1 6.28-.02 9.42-.02v-.02z",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.5 374.66c2.82 0 5.64-.07 8.46.02 4.05.13 5.69 1.75 5.78 5.65.06 2.74.09 5.5-.02 8.24-.13 3.11-2.28 5.17-5.07 5.07-2.72-.09-4.53-2.05-4.57-5.13-.06-4.12.78-4.19-4.53-4.18-4.8.01-4.8 0-5.21 4.76-.23 2.65-2.03 4.54-4.54 4.53-2.61 0-4.67-1.3-4.9-3.82-.34-3.73-.33-7.53 0-11.26.22-2.56 2.34-3.76 4.91-3.83 3.23-.08 6.47-.02 9.71-.02-.02-.02-.02-.03-.02-.03z",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.8 262.57c-2.71.02-5.03-2.23-4.99-4.86.04-2.47 2.27-4.71 4.78-4.8 2.64-.09 5.06 2.15 5.13 4.75.07 2.61-2.21 4.88-4.92 4.91z",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.88 257.7c.05 2.55-2.33 4.87-4.95 4.86-2.56-.01-4.79-2.11-4.9-4.59-.11-2.6 2.13-4.98 4.78-5.07 2.54-.08 5.03 2.27 5.07 4.8z",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.09 257.99c-.06 2.47-2.36 4.6-4.94 4.58-2.72-.02-4.93-2.31-4.81-4.99.11-2.53 2.37-4.68 4.88-4.66 2.47.01 4.93 2.58 4.87 5.07z",
    id: "path30"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(-257.828 -257.722) scale(1.85936)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.65,
    cy: 216.15,
    r: 10.01,
    id: "circle36",
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.69,
    cy: 216.15,
    r: 10.01,
    id: "circle38",
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.61,
    cy: 216.15,
    r: 10.01,
    id: "circle40",
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.56,
    cy: 216.15,
    r: 10.01,
    id: "circle42",
    style: {
      fill: "#e79933"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinars);
export default __webpack_public_path__ + "static/media/webinars.f93f4f8690412281804213acb2287eed.svg";
export { ForwardRef as ReactComponent };